
import Swal from 'sweetalert2'

function tratarMensagem(mensagem, ehHtml) {


  function montarListaErros(erros) {
    let tmp = '<ul>';
    erros.forEach(erro => tmp += `<li style='text-align:left'>${erro}<lit>`);
    return tmp += '</ul>';
  }

  if (Array.isArray(mensagem)) {
    if (!ehHtml) return mensagem.join('\n')
    else {
      mensagem = `<div class="alert alert-danger" role="alert">
      ${montarListaErros(mensagem)}
      </div>`;

    }
  }

  return mensagem;
}

function confirmacao(titulo, mensagem) {
  return Swal.fire({
    allowOutsideClick: false,
    title: titulo,
    html: mensagem,
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não'
  })
}

function sucesso(mensagem) {
  let msg = tratarMensagem(mensagem);

  return Swal.fire(
    {
      allowOutsideClick: false,
      title: 'Sucesso',
      html: msg,
      type: 'success'
    }
  )
}

function erro(mensagem, titulo, ehHtml) {
  const msg = tratarMensagem(mensagem, ehHtml);
  return Swal.fire({
    allowOutsideClick: false,
    type: 'error',
    title: titulo || 'Erro',
    html: msg
  })
}

function atencao(mensagem) {
  const msg = tratarMensagem(mensagem);
  return Swal.fire({
    allowOutsideClick: false,
    type: 'warning',
    title: 'Atenção',
    html: msg
  })
}

export default {
  confirmacao,
  sucesso,
  erro,
  atencao
}



// WEBPACK FOOTER //
// ./src/services/Notificacao.service.js